const createPromise = (task, callback) => {
  return new Promise((resolve, reject) => {
    try {
      const value = task();
      if (callback) {
        callback(value);
      }
      resolve(value);
    } catch (err) {
      if (callback) {
        callback(err);
      }
      reject(err);
    }
  });
};

const asyncLocalStorageGet = async (key) => {
  return createPromise(() => {
    const data = window.localStorage.getItem(key);
    return data ? JSON.parse(data) : {};
  });
};

const asyncLocalStorageSet = (key, activity = {}) => {
  return createPromise(() => {
    if (key) {
      window.localStorage.setItem(key, JSON.stringify(activity));
    }
  });
};

const asyncSessionStorageGet = async (key) => {
  return createPromise(() => {
    const data = window.sessionStorage.getItem(key);
    return data ? JSON.parse(data) : {};
  });
};

const asyncSessionStorageSet = (key, activity = {}) => {
  return createPromise(() => {
    window.sessionStorage.setItem(key, JSON.stringify(activity));
  });
};

export {
  asyncLocalStorageGet,
  asyncLocalStorageSet,
  asyncSessionStorageGet,
  asyncSessionStorageSet,
};
